import React from 'react'
import customHeaders, { getSpace } from '../../common/headers'
import add_icon from './img/add_icon.svg'
import { RavshanHttps } from '../../fetchUrls'
import { useState, useEffect } from 'react'
import { ButtonBasic, InputDynamicWidth, Tabs, Sceleton, NoDataContent } from "@lk-gtcom/ecomlab-components";
import { ModalAddNewWiki } from '../../components/Modal/ModalAddNewWiki/ModalAddNewWiki'
import useGeneralStore from '../../store/general'
import { ButtonActionDrop } from '../../components/Buttons/ButtonActionDrop/ButtonActionDrop'
import { ModalAlert } from '../../components/Modal/ModalAlert/ModalAlert'
import { AuthorAvatar } from '../ArticleComponents/AuthorAvatar/AuthorAvatar'
import { ButtonsSort } from '../../components/Buttons/BurronsSort/ButtonsSort'
import { TitlePage } from '../../components/TitlePage/TitlePage'
import ModalWarning from '../../components/Modal/ModalWarning/ModalWarning'
import starIcon from './img/bxs-star.svg';
import "../../components/NetworkGroups/NetworkGroups.scss"
import './WikiList.scss'
import { useNavigate } from 'react-router-dom'
import { ButtonWithIcon } from '../../components/Buttons/ButtonWithIcon/ButtonWithIcon'

const btn_sort2 = [
    { label: <span>A<br />Z</span>, value: 'name' },
    { label: 'По дате создания', value: 'date' }
]

const btn_tab = [
    { label: 'Общие', value: 'main' },
    { label: 'Проектные', value: 'project' }
];

const CardGroup = ({ ...props }) => {
    const {
        name,
        created_at,
        author,
        id,
        onClick,
        setIsModalDelete,
        setIsDrop,
        setId,
        setIsModalAlert,
        setTokenWiki,
        setIsModal,
        setCurrentWiki,
        ind,
        is_favorite
    } = props

    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const email = localStorage.getItem('email')

    const btns = [
        {
            btn: 'Редактировать',
            func: () => {
                setCurrentWiki(props)
                setId(id)
                setIsModal(true)
            },
        },
        {
            btn: 'Получить токен',
            func: () => {
                fetchProductIds(id)
            },
        },
        {
            btn: 'Удалить',
            func: () => {
                setIsModalDelete(true)
                setIsDrop(-1)
                setId(id)
            },
        }
    ];

    // Получение токена для wiki
    const fetchProductIds = (id) => {
        const url = ` https://portals.ecomru.ru/api/v2/article/wiki_token?wiki_id=${id}`
        fetch(url, { method: 'GET', headers })
            .then(async res => {
                if (res.ok) {
                    return res.json()
                }
                else {
                    const text = await res.json()
                    throw new Error(text?.detail)
                }
            })
            .then(json => {
                if (json) {
                    setIsModalAlert(true)
                    setTokenWiki(json)
                }
            })
            .catch(err => console.error(err))
    }

    return (
        <div className='card-item'
            key={id + name + ind}
            onClick={onClick}
            style={{ minHeight: 'auto' }}
        >
            <div className='card-item__top-content'>
                <div className='card-item__header'>
                    <div className='statistic-tasks'>
                        <div className='statistic-tasks__item'>
                            Дата создания - <span>
                                {created_at ? new Date(created_at)?.toLocaleDateString('ru-RU') : ' неизвестная дата'}
                            </span>
                        </div>
                    </div>
                    {is_favorite && <img
                        style={{ marginLeft: 'auto' }}
                        src={starIcon} alt="Избранное" />}
                    {(email == author?.login) && <ButtonActionDrop
                        size='s'
                        id={id}
                        btns={btns}
                    />}
                </div>
            </div>

            <div className='card-item__medium-content'>
                <h3 className='title'>{name}</h3>
                <AuthorAvatar
                    show_name={true}
                    author={author ? [author?.name, author?.color] : []}
                />
            </div>
        </div>
    )
}

const WikiList = ({ ...props }) => {
    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const { platforms = [], statuses = [], fetchFilters } = props
    const portalId = 'add-new-connection-portal'
    const [isModal, setIsModal] = useState(false)
    const [isModalDelete, setIsModalDelete] = useState(false)
    const [loading, setLoading] = useState(false)
    const [wikiList, setWikiList] = useState([])
    const [isDrop, setIsDrop] = useState(-1)
    const [id, setId] = useState(-1)
    const navigate = useNavigate()
    const [isModalAlert, setIsModalAlert] = useState(false)
    const [tokenWiki, setTokenWiki] = useState('')
    const [isFavorite, setIsFavorite] = useState(false)

    const [currentWiki, setCurrentWiki] = useState({})

    const [currentSort, setCurrentSort] = useState(null)
    const [sort, setSort] = useState(null)
    const [searchInput, setSearchInput] = useState('')
    const [pageValue, setPageValue] = useState(btn_tab[0].value)

    const fetchWikiList = (delay = false, page = false) => {
        setLoading(true)

        const controller = new AbortController();
        const signal = controller.signal;

        const request = () => {
            const sort_params = currentSort ? `&order_param=${currentSort?.value}&order_param_direction=${sort.toLowerCase()}` : '';
            const search_params = searchInput ? `&search=${searchInput}` : '';
            const isPage = `?type_project=${pageValue == 'project' ? 'true' : 'false'}`
            const isFavoriteParams = `&is_favorite=${isFavorite}`
            const url = `${RavshanHttps}/api/v2/article/wiki/get${isPage}${sort_params}${search_params}${isFavoriteParams}`;

            fetch(url, { method: 'GET', headers, signal })
                .then(res => {
                    if (!res?.ok) { throw new Error('bad response') }
                    return res.json();
                })
                .then(json => setWikiList(json))
                .catch(e => {
                    if (e.name !== 'AbortError') {
                        console.log(e);  // Игнорируем ошибку отмены запроса
                    }
                })
                .finally(() => {
                    if (signal.aborted) return;
                    setLoading(false);
                });
        }

        if (delay) {
            setTimeout(() => { request() }, delay);
        } else {
            request();
        }

        // Возвращаем контроллер, чтобы при необходимости можно было отменить запрос
        return controller;
    }


    const editWiki = (name, wiki_id) => {
        const url = `${RavshanHttps}/api/v2/article/wiki/create`

        const body = JSON.stringify({
            name,
            wiki_id
        })

        fetch(url, { body, method: 'POST', headers })
            .then(res => {
                if (!res?.ok) { throw new Error('bad response') }
                return res.json()
            })
            .then(json => {
                fetchWikiList()
            })
            .catch(e => console.log(e))
    }

    const onDeleteHandler = (id) => {
        const url = `${RavshanHttps}/api/v2/article/wiki/delete/${id}`

        fetch(url, { method: 'DELETE', headers })
            .then(res => {
                if (!res?.ok) { throw new Error('bad response') }
                return res.json()
            })
            .then(() => {
                const abortController = new AbortController()
                fetchWikiList(abortController.signal, 100)
            })
            .catch(e => console.log(e))
    }

    useEffect(() => {
        if (!isModal) {
            const abortController = new AbortController()

            fetchWikiList(abortController.signal, 100)

            return () => {
                abortController.abort()
            }
        }
    }, [isModal, selectedSpace, sort, currentSort, searchInput, pageValue, isFavorite])

    useEffect(() => {
        const closeMenu = (e) => {
            let el = e.target
            if (!el.closest('.drop-and-btn')) {
                setIsDrop(null)
            }
        }
        document.addEventListener('click', closeMenu)

        return () => {
            document.addEventListener('click', closeMenu)
        }
    }, [])

    useEffect(() => {
        fetchWikiList()
    }, [selectedSpace, sort, searchInput, currentSort]);

    useEffect(() => {
        if (!isModalAlert) {
            setTokenWiki('')
        }
    }, [isModalAlert]);

    return (
        <>
            {isModalAlert && <ModalAlert
                title={tokenWiki}
                copy={true}
                setIsModal={(e) => setIsModalAlert(e)}
            />}

            {isModal && <ModalAddNewWiki
                setIsModal={(e) => setIsModal(e)}
                currentWiki={currentWiki}
                setCurrentWiki={setCurrentWiki}
                fetchWikiList={fetchWikiList}
                setIsModalDelete={setIsModalDelete}
                onDeleteHandler={onDeleteHandler}
                id={id}
                setId={setId}
            />}

            {/* Удаление wiki */}

            {isModalDelete && <ModalWarning
                headerText='Подтвердите удаление'
                messageText={`Удалить wiki ID-${id}?`}
                approveButtonText='Удалить'
                cancelButtonText='Отмена'
                colorBtn='red'
                onApproveClick={() => {
                    onDeleteHandler(id)
                    setId(null)
                    setIsModalDelete(false)
                }}
                onCancelClick={() => setIsModalDelete(false)}
            />}

            <div id={portalId} className='wiki-list'>
                <TitlePage
                    title={'Мои wiki'}
                />

                <div className='wiki-list__toolbar'>
                    <ButtonBasic
                        green
                        onClick={(e) => {
                            setCurrentWiki(null)
                            setIsModal(true)
                        }}
                        icon={add_icon}
                        text={'Создать wiki'}
                        positionIcon='right'
                    />

                    <ButtonWithIcon
                        size='m'
                        favorite
                        changeValue={isFavorite}
                        onClick={(e) => setIsFavorite(!isFavorite)}
                    />

                    <ButtonsSort
                        btnSort={btn_sort2}
                        sort={sort}
                        setSort={setSort}
                        currentSort={currentSort}
                        setCurrentSort={setCurrentSort}
                    />

                    <InputDynamicWidth
                        position='left'
                        maxWidth='100%'
                        isOpen={true}
                        onChange={setSearchInput}
                        placeholder='Поиск'
                    />
                </div>

                <Tabs
                    tabs={btn_tab}
                    pageValue={pageValue}
                    setPageValue={setPageValue}
                />

                <div className='wiki-list__card-group'>
                    {loading ?
                        [...Array(8)].map((el, ind) => {
                            return <Sceleton
                                key={ind}
                                width={240}
                                height={152}
                            />
                        })
                        :
                        (wikiList.length ?
                            wikiList?.map((props, ind) => {
                                const { id, name, author } = props
                                return (
                                    <CardGroup
                                        key={id}
                                        ind={ind}
                                        {...props}
                                        onClick={e => {
                                            localStorage.setItem('wiki_id', id)
                                            localStorage.setItem('wiki_name', name)
                                            navigate(`/wiki/articles/wiki-${id}`)
                                        }}
                                        setId={setId}
                                        setIsDrop={setIsDrop}
                                        isDrop={isDrop}
                                        setIsModal={setIsModal}
                                        setIsModalDelete={e => setIsModalDelete(true)}
                                        setIsModalAlert={setIsModalAlert}
                                        setTokenWiki={setTokenWiki}
                                        setCurrentWiki={setCurrentWiki}
                                    />
                                )
                            })
                            :
                            <NoDataContent
                                // img={banner_no_data}
                                title="Нет доступных wiki"
                                description="Создайте новое wiki, чтобы пользоваться всеми инструментами сервиса"
                                child={
                                    <></>
                                }
                            />
                        )
                    }
                </div>
            </div >
        </>

    )
}

export default WikiList 